import { render } from "./TraitRanksUtilities.vue?vue&type=template&id=711b4228"
import script from "./TraitRanksUtilities.vue?vue&type=script&lang=js"
export * from "./TraitRanksUtilities.vue?vue&type=script&lang=js"

import "./TraitRanksUtilities.vue?vue&type=style&index=0&id=711b4228&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__